// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostIntelligentPartnerTaskInfosStatisticsFindAllExportBody,
    BaseResponseVoid,
} from '../../../../types';

/**
 * 任务报表导出
 *
 * @export
 * @tags 智能陪练发布任务接口
 * @link [POST] /intelligentPartnerTaskInfos/statistics/findAll/export
 */
export function postIntelligentPartnerTaskInfosStatisticsFindAllExport(
    data: PostIntelligentPartnerTaskInfosStatisticsFindAllExportBody
): Promise<BaseResponseVoid>;
export function postIntelligentPartnerTaskInfosStatisticsFindAllExport(
    data: PostIntelligentPartnerTaskInfosStatisticsFindAllExportBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postIntelligentPartnerTaskInfosStatisticsFindAllExport(
    data: PostIntelligentPartnerTaskInfosStatisticsFindAllExportBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostIntelligentPartnerTaskInfosStatisticsFindAllExportBody, never, never>(
        '/intelligentPartnerTaskInfos/statistics/findAll/export',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerTaskInfosStatisticsFindAllExport',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练发布任务接口'],
        path: '/intelligentPartnerTaskInfos/statistics/findAll/export',
        method: 'post',
    },
];
